/**
 * Centralized configuration for ARQITE UI
 * https://arqite-app-backend.onrender.com
 *   apiUrl: process.env.REACT_APP_API_URL || 'http://[::1]:3000', // Default for dev

 * Reads from environment variables and falls back to defaults where needed.
 */

export const Config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:4000',  
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  outlookClientId: process.env.REACT_APP_OUTLOOK_CLIENT_ID || '',

  // Feature flags
  featureFlags: {
    newUI: process.env.REACT_APP_FEATURE_FLAG_NEW_UI === 'true',
  },

  // App meta config
  app: {
    name: 'ARQITE Dashboard',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.NODE_ENV, // 'development', 'production', or 'test'
  },
};

export type AppConfig = typeof Config;

export default Config;
